export default __webpack_public_path__ + "static/media/publication.986330e6.svg";